<h2 mat-dialog-title>Lock receipt Correction?</h2>
<mat-dialog-content class="mat-typography">
  <p>Locking the receipt correction will trigger automatic creating of related `Expense` and `ExpenseItem(s)` objects, and additional correction will not be possible for this `Receipt`!</p>
  <p>Do you want to proceed? </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Lock Correction</button>
</mat-dialog-actions>
